import React, { Component } from 'react';

import { Container, Offcanvas, Row, Col,  Form } from 'react-bootstrap';

import CommonInput from '../components/CommonInput';
import CommonSelect from '../components/CommonSelect';
import CommonSuggestSelect from '../components/CommonSuggestSelect';
import CommonCheckbox from '../components/CommonCheckbox';
import CustomDatePicker from "../components/CommonDatePicker";
import CommonButton from '../components/CommonButton';
import CommonFile from '../components/CommonFile';

import CommonAlert from '../components/CommonAlert';
import CommonLoadingBar from '../components/CommonLoadingBar';

/**
    import CommonRadio from '../components/CommonRadio';
*/

import * as Actions from '../actions/ActionCenter';

import * as fn from '../../library/function';
import * as helper from '../../library/helper';
import * as util from '../../library/utilitys';

import SimpleBar from 'simplebar-react';

import InlineEB02DataTrainingDetails from '../inline/InlineEB02DataTrainingDetails';
import InlineEB02DataTrainingDetailsEnterprise from '../inline/InlineEB02DataTrainingDetailsEnterprise';
import InlineEB02DataExpensesEB02 from '../inline/InlineEB02DataExpensesEB02';

let GET_OFFICIAL_ENROLL_KEY = `api/master/get-official-enroll-key/`;

class InputEB02DataCourse extends Component {

    constructor(props) {
        super(props);
        this.state = {
            selectedDate: new Date(),
            DrillDowns: {
                training_details_enterprise: {
                    drilldown: false,
                    fk: null,
                    val: null,
                    page: null
                }
            }            
        }

        this.simpleBarRef = React.createRef();
        this.approvedRef = React.createRef();
    }

    handleDateChange = (date) => { this.setState({ selectedDate: date }); };

    prepareInputs = async () => {
        const { URL, Action, Inputs, onUpdateState } = this.props;
        const isUpdateMode = Action.Mode === 'update';

        let updatedInputs = fn.setRequiredPrimaryKey(Inputs, isUpdateMode);

        onUpdateState('Inputs', updatedInputs);
    }
    
    draftInput = async (object) => {
        const { onInputChange } = this.props;
        
        let element = object.target.id;
        console.log("element",element);
        
        let value = object.target.value;
        let targetField = '';
        
        if(element === 'course_eb_01_id'){ targetField = 'course_eb_01_name'; }
        else if(element === 'course_eb_01_name'){ targetField = 'course_eb_01_id';}

        onInputChange({ target: { name: targetField, value: value } }, 'Inputs');
    }    

    toggleDrillInline = ({ key, fk = null, val = null, page = null, drilldown = false }) => {
        this.setState(prevState => ({
            ...prevState,
            DrillDowns: {
                ...prevState.DrillDowns,
                [key]: {
                    ...prevState.DrillDowns[key],
                    drilldown,
                    fk,
                    val,
                    page
                }
            }
        }));
    };

    drilldownInline = (e) => { this.toggleDrillInline({ ...e, drilldown: true }); }

    generateEntollKey = async (e) => {
        let {val} = e;
        
        let result = await Actions.getSomething(this.updateState, GET_OFFICIAL_ENROLL_KEY + val , {});
        if(result.success){
            this.drillupInline({ key: 'training_details_enterprise'})
        }
    }

    drillupInline = ({ key }) => {
        this.toggleDrillInline({ key });
    }

    updateFlowStatus = async (e) => {
        let {id, value} = e?.target;

        const { Inputs, onUpdateState } = this.props;
        let updatedInputs = Inputs;

        if(id === 'hdc_status'){
            if(['', '1'].includes(value)){
                updatedInputs.authorized_status.value = '';
                updatedInputs.authorized_status.error.status = null;
                updatedInputs.authorizer_name.value = '';
                updatedInputs.authorizer_name.error.status = null;
                updatedInputs.authorized_date.value = '';
                updatedInputs.authorized_date.error.status = null;

                updatedInputs.authorizer_sign_file.fileId = '';
                updatedInputs.authorizer_sign_file.fileName = '';
                updatedInputs.authorizer_sign_file.file = {};
                updatedInputs.authorizer_sign_file.fileInfo = {};

                updatedInputs.authorized_status.validator.required = false;
                updatedInputs.authorizer_name.validator.required = false;
                updatedInputs.authorized_date.validator.required = false;

                // updatedInputs.office_signer_name.validator.required = false;
                // updatedInputs.office_sign_date.validator.required = false;
                // updatedInputs.hdc_reject_cause.validator.required = false;
            }
            if(['0', '1'].includes(value)){
                updatedInputs.office_signer_name.validator.required = true;
                updatedInputs.office_sign_date.validator.required = true;

                updatedInputs.hdc_reject_cause.validator.required = false;

                if(value === '1'){
                    updatedInputs.hdc_reject_cause.validator.required = true;
                }                
            }
        }

        if(id === 'authorized_status'){
            if(['', '1'].includes(value)){
                updatedInputs.course_status.value = '0';

                updatedInputs.authorized_status.validator.required = false;
                updatedInputs.authorizer_name.validator.required = false;
                updatedInputs.authorized_date.validator.required = false;                     
            }
            
            if(['0', '1'].includes(value)){
                updatedInputs.course_status.value = '1';

                updatedInputs.authorized_status.validator.required = true;
                updatedInputs.authorizer_name.validator.required = true;
                updatedInputs.authorized_date.validator.required = true;                
            }
        }

        if(id === 'course_status'){
            if(value === ''){
                updatedInputs.hdc_status.value = '';
                updatedInputs.hdc_status.error.status = null;
                updatedInputs.hdc_status.validator.required = false;

                updatedInputs.course_checked.value = '';
                updatedInputs.budget_within_criteria.value = '';
                
                updatedInputs.office_signer_name.value = '';
                updatedInputs.office_signer_name.error.status = null;
                updatedInputs.office_sign_date.value = '';
                updatedInputs.office_sign_date.error.status = null;

                updatedInputs.office_sign_file.fileId = '';
                updatedInputs.office_sign_file.fileName = '';
                updatedInputs.office_sign_file.file = {};
                updatedInputs.office_sign_file.fileInfo = {};
                

                updatedInputs.authorized_status.value = '';
                updatedInputs.authorized_status.error.status = null;
                updatedInputs.authorized_status.validator.required = false;

                updatedInputs.authorizer_name.value = '';
                updatedInputs.authorizer_name.error.status = null;
                updatedInputs.authorized_date.value = '';
                updatedInputs.authorized_date.error.status = null;

                updatedInputs.authorizer_sign_file.fileId = '';
                updatedInputs.authorizer_sign_file.fileName = '';
                updatedInputs.authorizer_sign_file.file = {};
                updatedInputs.authorizer_sign_file.fileInfo = {};
            }
            if(value === '0'){
                updatedInputs.budget_code.validator.required = false;
                updatedInputs.operator_name.validator.required = false;
                updatedInputs.operator_sign_file.validator.required = false;
                
                updatedInputs.hdc_status.validator.required = false;
                updatedInputs.course_checked.validator.required = false;
                updatedInputs.authorized_status.validator.required = false;
            }        
            if(['1'].includes(value)){
                updatedInputs.budget_code.validator.required = true;
                updatedInputs.operator_name.validator.required = true;
                updatedInputs.operator_sign_file.validator.required = true;
            }
            if(['1', '2', '3'].includes(value)){
                updatedInputs.hdc_status.validator.required = true;
                updatedInputs.course_checked.validator.required = true;
                updatedInputs.authorized_status.validator.required = true;
            }
        }  

        console.log(updatedInputs);
        onUpdateState('Inputs', updatedInputs);          
    }

    componentDidUpdate = async (prevProps) => {
        if (fn.shouldPrepareInputs(prevProps.Action, this.props.Action)) {
            this.resetState();
            await this.prepareInputs();
        }

        if(prevProps.Action.Mode !== this.props.Action.Mode && this.props.Action.Mode === 'update'){
            const { Inputs } = this.props;
            this.draftInput( {target:{ id: 'course_eb_01_id' , value: Inputs.course_eb_01_id.value} });

            if (this.props.Approved) {
                setTimeout(() => {
                    const approvedEl = this.approvedRef?.current;
                    const simpleBarContent = this.simpleBarRef?.current?.getScrollElement?.();

                    if (approvedEl && simpleBarContent) {
                        const offsetTop = approvedEl.offsetTop;

                        simpleBarContent.scrollTo({
                            top: offsetTop,
                            behavior: 'smooth'
                        });
                    }
                }, 300); 
            }            
        }        
    }

    resetState = () => {
        this.setState({
            selectedDate: new Date(),
            DrillDowns: {
            training_details_enterprise: {
                drilldown: false,
                fk: null,
                val: null,
                page: null
            }
            }
        });
    };    

    render = () => {
        let props = this.props;

        let { onNavigate, onInputChange, onCloseAlert, onSubmit, userProfile, onDiscardSubmit, onPreviewFile, onDeleteFile  } = props;

        let { App, Action, Inputs, ReadOnlys, InputGroup, Masterbase, Operation, UserCookie } = props;      
        
        let { DrillDowns } = this.state;

        let { Submit } = Operation;
        
        let { show, mode } = Action.OffCanvas;

        let isLoading = Action.Loading.submit;

        return (
            <Offcanvas 
                show={show}
                placement="end" 
                style={{ '--bs-offcanvas-width': '100vw' }}
                backdrop={Submit ? "static" : true}
                onHide={(e) => props.onClose(e)}
            >
                <Offcanvas.Header closeButton className="border-bottom custom-offcanvas-header">
                    <Offcanvas.Title className="custom-offcanvas-header offcanvas-title"><i className={`${App.icon} text-white me-2`}/>{App.title}</Offcanvas.Title>
                </Offcanvas.Header>

                <Offcanvas.Body className="custom-offcanvas-body">
                    
                    <CommonAlert 
                        alert={Action.Alert} 
                        
                        callback={(e) => onCloseAlert(e)}
                    />

                    <SimpleBar id="inputs" className="simple-bar-input" ref={this.simpleBarRef}>
                        <Container fluid className="data-table-container">

                            <Row>
                                <Col md={{ span: 10, offset: 1 }} className="eb-form-container">
                                    
                                    <Row>
                                        <Col md={12} className="d-flex align-items-center justify-content-center text-center">
                                            <h5>แบบขออนุมัติจัดอบรมระยะสั้นตามแนวทางอีอีซีโมเดล</h5>
                                        </Col>
                                    </Row>

                                    <Row className="mt-3">
                                        <Col md={3} className="mb-3">{util.formatLabel('1. ', Inputs.course_eb_01_id)}</Col>
                                        <Col md={6} className="mb-3">
                                            {/* <CommonSelect
                                                element="Inputs"
                                                input={Inputs.course_eb_01_id}
                                                option={{source: 'db', data: Masterbase?.course_eb_01}}
                                                instanceOptionName="official_course_code"
                                                hr={false}
                                                floatingLabel={false}
                                                callback={async (e, element) => { 
                                                    await onInputChange(e, element);
                                                    await this.draftInput(e);
                                                }} 
                                            /> */}
                                            
                                            <CommonSuggestSelect
                                                element="Inputs"
                                                input={Inputs.course_eb_01_id}
                                                option={{source: 'db', data: Masterbase?.course_eb_01}}
                                                instanceOptionName="official_course_code"
                                                hr={false}
                                                floatingLabel={false}
                                                callback={async (e, element) => { 
                                                    await onInputChange(e, element);
                                                    await this.draftInput(e);
                                                }} 
                                            />
                                        </Col>
                                    </Row>

                                    <Row>
                                        <Col md={3} className="mb-3">  {util.formatLabel('2. ', Inputs.course_eb_01_name)}</Col>
                                        <Col md={9} className="mb-3">
                                            <CommonSelect
                                                element="Inputs"
                                                input={Inputs.course_eb_01_name}
                                                option={{source: 'db', data: Masterbase?.course_eb_01}}
                                                hr={false}
                                                floatingLabel={false}
                                                callback={async (e, element) => { 
                                                    await onInputChange(e, element);
                                                    await this.draftInput(e);
                                                }} 
                                            />                                     
                                        </Col>
                                    </Row> 

                                    <Row>
                                        <Col md={3} className="mb-3">  {util.formatLabel('3. ', Inputs.academy_id)}</Col>
                                        <Col md={9} className="mb-3">
                                            <CommonSelect
                                                element="Inputs"
                                                input={Inputs.academy_id}
                                                option={{source: 'db', data: Masterbase?.academy}}
                                                hr={false}
                                                floatingLabel={false}
                                                callback={(e, element) => onInputChange(e, element)}
                                                disabled={!['0','1'].includes(UserCookie?.types)}
                                            />                                   
                                        </Col>
                                    </Row>    

                                    <Row>
                                        <Col md={3} className="mb-3">{util.formatLabel('4. ', Inputs.course_responser)}</Col>
                                        <Col md={3} className="mb-3">
                                            <CommonInput
                                                element="Inputs"
                                                input={Inputs.course_responser}
                                                hr={false}
                                                floatingLabel={false}
                                                callback={async (e, element) => await onInputChange(e, element)} 
                                            />                                     
                                        </Col>
                                        <Col md={1} className="mb-3">
                                            {util.formatLabel(null, Inputs.course_responser_contact)}
                                        </Col>
                                        <Col md={2} className="mb-3">
                                            <CommonInput
                                                element="Inputs"
                                                input={Inputs.course_responser_contact}
                                                hr={false}
                                                floatingLabel={false}
                                                callback={async(e, element) => onInputChange(e, element)} 
                                            />                                   
                                        </Col>                                         
                                    </Row> 

                                    <Row>
                                        <Col md={3} className="mb-3">{util.formatLabel('5. ', Inputs.registration_fee, ' (บาท/คน)')}</Col>
                                        <Col md={3} className="mb-3">
                                            <CommonInput
                                                element="Inputs"
                                                input={Inputs.registration_fee}
                                                hr={false}
                                                floatingLabel={false}
                                                callback={async (e, element) => await onInputChange(e, element)} 
                                            />                                     
                                        </Col>
                                        <Col md={1} className="mb-3">
                                            {util.formatLabel(null, {label: 'บาท/คน'})}
                                        </Col>    
                                    </Row> 

                                    <Row>
                                        <Col md={12} className="mb-3">{util.formatLabel('6. ', {label : 'รายละเอียดการฝึกอบรมที่ขออนุมัติ (ขอได้คราวละมากกว่า 1 รุ่น รวมระยะเวลาไม่เกิน 1 เดือน)', validator: {required: true}} )}</Col>
                                    </Row>   
                                    {DrillDowns.training_details_enterprise.drilldown === false && (
                                        <Row>
                                            <Col md={{ span: 12, offset: 0 }} className="mb-3">
                                                <InlineEB02DataTrainingDetails 
                                                    fkId="course_eb_02_id"
                                                    fkVal={Inputs.id.value}
                                                    fkUserCookie={UserCookie}

                                                    onDrillDownInline={(e) => this.drilldownInline(e)}
                                                    onGenEnrollKey={(e) => this.generateEntollKey(e)}
                                                />
                                            </Col>                                        
                                        </Row>
                                    )}
                                    {DrillDowns.training_details_enterprise.drilldown === true && (
                                            <Row>
                                                <Col md={{ span: 12, offset: 0 }} className="mb-3">
                                                    <InlineEB02DataTrainingDetailsEnterprise
                                                        refKey='training_details_enterprise'
                                                        refPage={DrillDowns.training_details_enterprise.page}
                                                        
                                                        fkId="training_details_eb_02_id"
                                                        fkVal={DrillDowns.training_details_enterprise.val}

                                                        onDrillUpInline={(e) => this.drillupInline(e)}
                                                    />
                                                </Col>                                        
                                            </Row>
                                    )}   

                                    <Row>
                                        <Col md={4} className="mb-3">{util.formatLabel('7. ', Inputs.total_budget, ' (โปรดระบุงบประมาณรวมทั้งโครงการ)')}</Col>
                                        <Col md={3} className="mb-3">
                                            <CommonInput
                                                element="Inputs"
                                                input={Inputs.total_budget}
                                                hr={false}
                                                floatingLabel={false}
                                                callback={async (e, element) => await onInputChange(e, element)} 
                                            />                                     
                                        </Col>
                                        <Col md={1} className="mb-3">
                                            {util.formatLabel(null, {label: 'บาท'})}
                                        </Col>    
                                    </Row> 

                                    <Row>
                                        <Col md={{ span: 12, offset: 0 }} className="mb-3">
                                            <InlineEB02DataExpensesEB02 
                                                fkId="course_eb_02_id"
                                                fkVal={Inputs.id.value}
                                            />
                                        </Col>                                        
                                    </Row>  
                                    
                                    <Row>
                                        <Col md={6} className="mb-3">{util.formatLabel('8. ', Inputs.budget_request_to_hdc , 'จาก สกพอ. (ไม่เกินร้อยละ 50 ของค่าใช้จ่ายจริง)')}</Col>
                                        <Col md={2} className="mb-3">
                                            <CommonInput
                                                element="Inputs"
                                                input={Inputs.budget_request_to_hdc}
                                                hr={false}
                                                floatingLabel={false}
                                                callback={async (e, element) => await onInputChange(e, element)} 
                                            />                                     
                                        </Col>
                                        <Col md={1} className="mb-3">
                                            {util.formatLabel(null, {label: 'บาท'})}
                                        </Col>    
                                    </Row>   

                                    <Row>
                                        <Col md={6} className="mb-3">{util.formatLabel('9. ', Inputs.budget_support_by_hdc, ' ที่ สกพอ. สนับสนุน (ไม่เกินร้อยละ 50 ของค่าใช้จ่ายจริง)')}</Col>
                                        <Col md={2} className="mb-3">
                                            <CommonInput
                                                element="Inputs"
                                                input={Inputs.budget_support_by_hdc}
                                                hr={false}
                                                floatingLabel={false}
                                                callback={async (e, element) => await onInputChange(e, element)} 
                                            />                                     
                                        </Col>
                                        <Col md={1} className="mb-3">
                                            {util.formatLabel(null, {label: 'บาท'})}
                                        </Col>    
                                    </Row>    

                                    <Row><Col md={12}><hr/></Col></Row>
                                    <Row>                                        
                                        <Col md={12} className="mb-3">
                                            {util.formatLabel('10. ', {label: 'ลงนามโดยผู้บริหารสถานศึกษาที่มีอำนาจลงนามผูกพันนิติบุตตลหรือผู้ที่ได้รับมอบอำนาจ'})}
                                        </Col>
                                    </Row>  
                                    <Row>
                                        <Col md={3} className="mb-3 text-end">{util.formatLabel(null, Inputs.academy_signer_name)}</Col> 
                                        <Col md={2} className="mb-3">
                                            <CommonInput
                                                element="Inputs"
                                                input={Inputs.academy_signer_name}
                                                hr={false}
                                                floatingLabel={false}
                                                callback={(e, element) => onInputChange(e, element)} 
                                            />                                        
                                        </Col>  
                                        <Col md={1} className="mb-3 text-end">{util.formatLabel(null, Inputs.academy_signer_position)}</Col> 
                                        <Col md={2} className="mb-3">
                                            <CommonInput
                                                element="Inputs"
                                                input={Inputs.academy_signer_position}
                                                hr={false}
                                                floatingLabel={false}
                                                callback={(e, element) => onInputChange(e, element)} 
                                            />                                        
                                        </Col>  
                                         <Col md={1} className="mb-3 text-end">{util.formatLabel(null, Inputs.academy_sign_date)}</Col>
                                         <Col md={2} className="mb-3">
                                            <CustomDatePicker
                                                element="Inputs"
                                                input={Inputs.academy_sign_date}
                                                hr={false}
                                                floatingLabel={false}
                                                callback={(e, element) => onInputChange(e, element)} 
                                            />
                                         </Col>                                                                                
                                    </Row>  
                                    <Row ref={this.approvedRef}>
                                        <Col md={3} className="mb-3 text-end">{util.formatLabel(null, Inputs.academy_sign_file)}</Col> 
                                        <Col md={9} className="mb-3">
                                            <CommonFile
                                                element="Inputs"
                                                input={Inputs.academy_sign_file}
                                                hr={false}
                                                floatingLabel={false}
                                                callback={(e, element) => onInputChange(e, element)} 

                                                previewFile={(e) => onPreviewFile(e)} 
                                                deleteFile={(e) => onDeleteFile(e, Inputs.id)} 
                                            />                                  
                                        </Col>
                                    </Row>                                     

                                    {!util.isEmpty(Inputs.course_status.value) && !['2'].includes(UserCookie.types) && (
                                        <>
                                            <Row><Col md={12}><hr/></Col></Row>
                                            <Row>                                        
                                                <Col md={12} className="mb-3">
                                                    <i className="text-info fa-classic fa-solid fa-user fa-fw me-2"></i>
                                                    {util.formatLabel('', {label: 'สำหรับเจ้าหน้าที่ สกพอ.'})}
                                                </Col>
                                            </Row>  
                                            <Row>
                                                <Col md={3} className="mb-3 text-end">
                                                    {util.formatLabel('', {label: 'ตรวจสอบหลักสูตร'}) }
                                                    <i
                                                    className="fa-classic fa-light fa-asterisk fa-fw"
                                                    style={{ fontSize: '0.5rem', verticalAlign: 'text-top' }}
                                                    aria-hidden="true"
                                                    />
                                                </Col>
                                                <Col md={6} className="mb-3">
                                                    <CommonCheckbox
                                                        element="Inputs"
                                                        input={Inputs}
                                                        checkbox={InputGroup.Checkbox.input_eec_hdc}
                                                        hr={false}
                                                        callback={(e, element) => onInputChange(e, element)} 
                                                    />                                        
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col md={3} className="mb-3 text-end">
                                                    {util.formatLabel('', {label: 'อนุมัติ'})}
                                                    <i
                                                        className="fa-classic fa-light fa-asterisk fa-fw"
                                                        style={{ fontSize: '0.5rem', verticalAlign: 'text-top' }}
                                                        aria-hidden="true"
                                                    />
                                                </Col>
                                                <Col md={3} className="mb-3">
                                                    <CommonSelect
                                                        element="Inputs"
                                                        input={Inputs.hdc_status}
                                                        option={{source: 'options', section: 'status', item: 'eb02_course_eec_hdc'}}
                                                        hr={false}
                                                        disabled={Inputs.course_checked.value === '1' || Inputs.budget_within_criteria.value === '1' ? false : true}
                                                        callback={async (e, element) => {
                                                            await onInputChange(e, element);
                                                            await this.updateFlowStatus(e);
                                                        }} 
                                                    />                                      
                                                </Col>
                                            </Row>   
                                            {Inputs.hdc_status.value === '1' && (
                                                <Row>
                                                    <Col md={3} className="mb-3 text-end">
                                                        <label className="form-label">
                                                            ไม่สมควรอนุมัติเนื่องจาก
                                                            <i
                                                                className="fa-classic fa-light fa-asterisk fa-fw ms-2"
                                                                style={{ fontSize: '0.5rem', verticalAlign: 'text-top' }}
                                                            ></i>
                                                        </label>
                                                    </Col>
                                                    <Col md={9} className="mb-3">                                                
                                                        <CommonInput
                                                            element="Inputs"
                                                            input={Inputs.hdc_reject_cause}
                                                            hr={false}
                                                            floatingLabel={false}
                                                            callback={(e, element) => onInputChange(e, element)} 
                                                        />                                                
                                                    </Col>
                                                </Row> 
                                            )}                                                                       
                                            <Row>
                                                <Col md={3} className="mb-3 text-end">{util.formatLabel(null, Inputs.office_signer_name)}</Col> 
                                                <Col md={2} className="mb-3">
                                                    <CommonInput
                                                        element="Inputs"
                                                        input={Inputs.office_signer_name}
                                                        hr={false}
                                                        floatingLabel={false}
                                                        callback={(e, element) => onInputChange(e, element)} 
                                                    />                                        
                                                </Col> 
                                                <Col md={1} className="mb-3 text-end">{util.formatLabel(null, Inputs.office_sign_date)}</Col>
                                                <Col md={2} className="mb-3">
                                                    <CustomDatePicker
                                                        element="Inputs"
                                                        input={Inputs.office_sign_date}
                                                        hr={false}
                                                        floatingLabel={false}
                                                        callback={(e, element) => onInputChange(e, element)} 
                                                    />
                                                </Col>                                           
                                            </Row>                                  
                                            <Row>
                                                <Col md={3} className="mb-3 text-end">{util.formatLabel(null, Inputs.office_sign_file)}</Col> 
                                                <Col md={9} className="mb-3">
                                                    <CommonFile
                                                        element="Inputs"
                                                        input={Inputs.office_sign_file}
                                                        hr={false}
                                                        floatingLabel={false}
                                                        callback={(e, element) => onInputChange(e, element)} 

                                                        previewFile={(e) => onPreviewFile(e)} 
                                                        deleteFile={(e) => onDeleteFile(e, Inputs.id)} 
                                                    />                                        
                                                </Col>
                                            </Row>                                            
                                        </>
                                    )}

                                    {!util.isEmpty(Inputs.course_status.value) && ['0', '1'].includes(UserCookie.types) && ( //!util.isEmpty(Inputs.hdc_status.value)
                                        <>
                                            <Row><Col md={12}><hr/></Col></Row>
                                            <Row>                                        
                                                <Col md={12} className="mb-3">
                                                    <i className="text-success fa-classic fa-solid fa-user-check fa-fw me-2"></i>
                                                    {util.formatLabel('', Inputs.authorized_status)}
                                                </Col>
                                            </Row>   
                                            <Row>
                                                <Col md={3} className="text-end">
                                                    {util.formatLabel('', {label: 'อนุมัติ'})}
                                                </Col>
                                                <Col md={3} className="mb-3">
                                                    <CommonSelect
                                                        element="Inputs"
                                                        input={Inputs.authorized_status}
                                                        option={{source: 'options', section: 'status', item: 'eb02_course_authorize'}}
                                                        hr={false}
                                                        floatingLabel={false}
                                                        callback={async(e, element) => {
                                                            await onInputChange(e, element);
                                                            await this.updateFlowStatus(e);
                                                        }} 
                                                    />                                    
                                                </Col>
                                            </Row>  
                                            <Row>
                                                <Col md={3} className="mb-3 text-end">{util.formatLabel(null, Inputs.authorizer_name)}</Col> 
                                                <Col md={2} className="mb-3">
                                                    <CommonInput
                                                        element="Inputs"
                                                        input={Inputs.authorizer_name}
                                                        hr={false}
                                                        floatingLabel={false}
                                                        callback={(e, element) => onInputChange(e, element)} 
                                                    />                                        
                                                </Col> 
                                                <Col md={1} className="mb-3 text-end">{util.formatLabel(null, Inputs.authorized_date)}</Col>
                                                <Col md={2} className="mb-3">
                                                    <CustomDatePicker
                                                        element="Inputs"
                                                        input={Inputs.authorized_date}
                                                        hr={false}
                                                        floatingLabel={false}
                                                        callback={(e, element) => onInputChange(e, element)} 
                                                    />
                                                </Col>                                           
                                            </Row>                                  
                                            <Row>
                                                <Col md={3} className="mb-3 text-end">{util.formatLabel(null, Inputs.authorizer_sign_file)}</Col> 
                                                <Col md={9} className="mb-3">
                                                    <CommonFile
                                                        element="Inputs"
                                                        input={Inputs.authorizer_sign_file}
                                                        hr={false}
                                                        floatingLabel={false}
                                                        callback={(e, element) => onInputChange(e, element)} 

                                                        previewFile={(e) => onPreviewFile(e)} 
                                                        deleteFile={(e) => onDeleteFile(e, Inputs.id)} 
                                                    />                                      
                                                </Col>
                                            </Row>                                         
                                        </>
                                    )} 

                                    <Row>
                                        <Col md={12}>
                                            <hr className="hr-custom" />
                                        </Col>
                                    </Row>   

                                    <Row className="mt-3">
                                        <Col md={3} className="mb-3">
                                            <i className="text-primary fa-classic fa-solid fa-arrow-progress fa-fw me-2"></i>
                                            {util.formatLabel(null, {label: 'สถานะการจัดอบรม', validator: {required: true}})}
                                        </Col> 
                                        <Col md={5} className="mb-3">
                                            <CommonSelect
                                                element="Inputs"
                                                input={Inputs.course_status}
                                                option={{source: 'options', section: 'status', item: 'eb02_course_status'}}
                                                hr={false}
                                                floatingLabel={false}
                                                callback={async (e, element) => {
                                                    await onInputChange(e, element);
                                                    await this.updateFlowStatus(e);
                                                    await onInputChange(e, element);
                                                }} 
                                            />                                        
                                        </Col>
                                    </Row>                                    

                                    { ['0', '1', '2'].includes(UserCookie.types) && UserCookie?.subtypes === "0" &&(
                                        <>
                                            <Row><Col md={12}><hr/></Col></Row>
                                            <Row>
                                                <Col md={12} className="mb-3">
                                                    <i className="text-warning fa-classic fa-solid fa-sack-dollar fa-fw"></i>
                                                    {util.formatLabel('', {label: 'ข้อมูลสำหรับการกันเงิน'})}
                                                </Col>
                                            </Row>   
                                            <Row>
                                                <Col md={3} className="text-end">
                                                    {util.formatLabel('', Inputs.budget_code)}
                                                </Col>
                                                <Col md={3} className="mb-3">
                                                    <CommonInput
                                                        element="Inputs"
                                                        input={Inputs.budget_code}
                                                        hr={false}
                                                        floatingLabel={false}
                                                        callback={(e, element) => onInputChange(e, element)} 
                                                    />                                  
                                                </Col>
                                            </Row>    
                                            <Row>
                                                <Col md={3} className="mb-3 text-end">{util.formatLabel(null, Inputs.operator_name)}</Col> 
                                                <Col md={2} className="mb-3">
                                                    <CommonInput
                                                        element="Inputs"
                                                        input={Inputs.operator_name}
                                                        hr={false}
                                                        floatingLabel={false}
                                                        callback={(e, element) => onInputChange(e, element)} 
                                                    />                                        
                                                </Col> 
                                                <Col md={1} className="mb-3 text-end">{util.formatLabel(null, Inputs.finance_date)}</Col>
                                                <Col md={2} className="mb-3">
                                                    <CustomDatePicker
                                                        element="Inputs"
                                                        input={Inputs.finance_date}
                                                        hr={false}
                                                        floatingLabel={false}
                                                        callback={(e, element) => onInputChange(e, element)} 
                                                    />
                                                </Col>                                           
                                            </Row>    
                                        <Row>
                                                <Col md={3} className="mb-3 text-end">{util.formatLabel(null, Inputs.operator_sign_file)}</Col> 
                                                <Col md={9} className="mb-3">
                                                    <CommonFile
                                                        element="Inputs"
                                                        input={Inputs.operator_sign_file}
                                                        hr={false}
                                                        floatingLabel={false}
                                                        callback={(e, element) => onInputChange(e, element)} 

                                                        previewFile={(e) => onPreviewFile(e)} 
                                                        deleteFile={(e) => onDeleteFile(e, Inputs.id)} 
                                                    />                                        
                                                </Col>
                                            </Row>
                                        </>
                                    )}                                                                                                                                                                                                                                                                                                                                                      
                                                                                                                                                                                                                                                                                                                                                
                                </Col>
                            </Row>                            

                        </Container>
                    </SimpleBar>

                </Offcanvas.Body>
                
                {UserCookie?.types != "6" &&(
                    <>
                        <div className="offcanvas-footer d-flex flex-column border-top bg-light p-3">
                            
                            <CommonLoadingBar isLoading={isLoading} />

                            <div className="d-flex justify-content-end mt-2">
                                <CommonButton 
                                    task={mode} 
                                    disabled={isLoading ? true : Submit ? false : true}
                                    callback={async (e) => { 
                                        await onSubmit(e);
                                    }} 
                                />

                                {Action.Mode === 'new' && (
                                    <CommonButton 
                                        task="discard" 
                                        inlineClass="ms-1" 
                                        disabled={isLoading} 
                                        callback={(e) => onDiscardSubmit(false)} 
                                    />
                                )}
                            </div>
                        </div>
                    </>
                )}
            </Offcanvas>             
        )
    }    
}

export default InputEB02DataCourse;        